import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import DashboardPage from '../pages/DashboardPage';

/**
 * На корне (/) и /dashboard: преподаватель → кабинет преподавателя,
 * родитель без роли ученика → кабинет родителя.
 */
export default function DashboardOrRedirect() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
        <p>Загрузка...</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.is_teacher) {
    return <Navigate to="/teacher" replace />;
  }

  if (user.is_parent && !user.is_student) {
    return <Navigate to="/parent" replace />;
  }

  return <DashboardPage />;
}
